// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { initialize } from 'redux-form'

const clearRadioValues = sourceForm => (dispatch, getState) => {
  const { bandId } = getState().form[sourceForm].values

  const initialValues = {
    architecture: '%',
    bandId,
    bandwidth:'',
    modelNumber:'',
    modulationType: '%',
    radioCode:'',
    throughput:'',
    pagination: null,
  }

  dispatch(initialize(sourceForm, initialValues))
}

export default clearRadioValues